import styled from "styled-components"

const DealsLoader = styled.div`
  transition: filter 0.5s;
  filter: ${(props) => (props.isLoading ? "grayscale(75%)" : "none")};
`

export default DealsLoader
